import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPageTitleStyles {
    container?: GridContainerProps;
    brandGridItem?: GridItemProps;
    brandStyles?: ProductBrandStyles;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
}

export const pageTitleStyles: ProductDetailsPageTitleStyles = {
    /* Store Custom Code - Start */
    container: {
        gap: 0,
        css: css`
            width: 100%;
        `,
    },
    brandGridItem: {
        width: 12,
        css: css`
            margin-bottom: 10px !important;
        `,
    },
    brandStyles: {
        logoImage: {
            css: css`
                img {
                    max-width: 150px;
                    max-height: 150px;
                }
            `,
        },
        nameText: {
            size: 16,
            weight: "normal",
        },
    },
    titleGridItem: {
        css: css`
            width: 100%;
            max-width: inherit;
            flex-basis: inherit;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: ["0.5em !important", null, "0 !important", null, null],
                            properties: ["margin-top"],
                        },
                        {
                            values: ["column", null, "row", null, null],
                            properties: ["flex-direction"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    titleText: {
        variant: "h1",
        css: css`
            margin-right: 50px;
        `,
    },
    /* Store Custom Code - End */
};

const styles = pageTitleStyles;

const ProductDetailsPageTitle: React.FC<Props> = ({ product }) => {
    return (
        <GridContainer {...styles.container}>
            {/* Store Custom Code - Removed product.brand */}
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.titleText} data-test-selector="productDetails_productDescription">
                    {product.productTitle}
                </Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPageTitle),
    definition: {
        displayName: "Page Title",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
